import { WebStorageStateStore } from 'oidc-client-ts';

import { AUTHORITY, CLIENT_ID, CLIENT_SECRET } from '@/constants';

import type { AuthProviderProps } from 'react-oidc-context';

export const oidcConfig: AuthProviderProps = {
  authority: AUTHORITY,
  client_id: CLIENT_ID,
  client_secret: CLIENT_SECRET,
  redirect_uri: window.location.href,
  post_logout_redirect_uri: window.location.origin,
  staleStateAgeInSeconds: 3600,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback: () => {
    window.history.replaceState({}, '', window.location.pathname);
  },
};
